import Heading from '../../components/atoms/Heading'
import Layout from '../../templates/Layout'
import { useUser } from '../../providers/User'
import { Role } from '../../types/enums'
import InvoicesTable from '../../templates/InvoicesTable'

const PendingInvoicesPage = () => {
  const { user } = useUser()
  return (
    <Layout>
      {[Role.Director, Role.Finance, Role.Admin].includes(user!.role as Role) && (
        <>
          <Heading type="1" border margin>
            Facturas En Analisis
          </Heading>
          <InvoicesTable status="analysis"/>
        </>
      )}
      {[Role.Director, Role.Finance, Role.Admin].includes(user!.role as Role) && (
        <>
          <Heading type="1" border margin>
            Facturas Listas Para Facturar
          </Heading>
          <InvoicesTable status="pending"/>
        </>
      )}
    </Layout>
  )
}

export default PendingInvoicesPage
